import { DELETEPOLICY_SUCCESS, DELETEPOLICY_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const deletePolicyReducer = (state = initialState, action) => {
    switch (action.type) {
        case DELETEPOLICY_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case DELETEPOLICY_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default deletePolicyReducer;
